// Texts for the product page
const product = {
    offer: 'Oferta',

    addProduct: 'Agregar',
    deleteProduct: 'Eliminar',
    updateProduct: 'Editar',

    productTitlePlaceholder: 'Nombre del producto',
    productDescriptionPlaceholder: 'Descripción del producto',
    productPricePlaceholder: 'Precio',

    imageAddText: 'Agregar una imagen',
    imageImport: 'Importar',

    imageDeleteVerificationText: '¿Estás seguro de que querés eliminar esta imagen?',
    productDeletVerificationText: '¿Estás seguro de que querés eliminar este producto?',
};

export default product;
